import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { Product } from '../../bean/shop/product';
import { Events } from 'ionic-angular';
import { Option } from "../../bean/shop/option";
import { ProductOption } from "../../bean/shop/product_option";

const CART_KEY = 'vesapa_cart';
const PROMOTION_KEY = 'vesapa_promotion';

@Injectable()
export class CartProvider {
    products: Product[] = [];
    isLoad: boolean = false;
    coupon: string = '';
    voucher: string = '';
    coupon_value: number = 0;
    voucher_value: number = 0;
    constructor(
        public storage: Storage,
        public events: Events
    ) {
        this.init();
    }

    init() {
        this.getCart().then(result => {
            console.log('Init cart');
            if (result) {
                this.products = result;
                this.isLoad = true;
                this.events.publish('cart:update', this.getQuantityProducts());
            }
        });

        this.getPromotion().then(result => {
            if (result) {
                if ('coupon' in result) {
                    this.coupon = result['coupon'];
                }
                if ('voucher' in result) {
                    this.voucher = result['voucher'];
                }
            }
        })
    }

    increaseProductItem(product: Product) {
        let isFound = false;
        for (let item of this.products) {
            if (item.id === product.id && item.uid === product.uid) {
                item.quantity += 1;
                isFound = true;
                break;
            }
        }
        if (!isFound) {
            product.quantity = 1;
            this.products.push(product);
        }
        this.events.publish('cart:update', this.getQuantityProducts());
        this.events.publish('cart:amount', this.getTotalPrice());
        return this.storage.set(CART_KEY, this.products);
    }

    updateProductItem(product: Product) {
        let isFound = false;
        for (let item of this.products) {
            if (item.id === product.id && item.uid === product.uid) {
                item.quantity = product.quantity;
                isFound = true;
                break;
            }
        }
        if (!isFound) {
            product.quantity = 1;
            this.products.push(product);
        }
        this.events.publish('cart:update', this.getQuantityProducts());
        this.events.publish('cart:amount', this.getTotalPrice());
        return this.storage.set(CART_KEY, this.products);
    }

    decreaseProductItem(product: Product) {
        let cartChange = false;
        this.products.forEach((item, index) => {
            if (item.id === product.id && item.uid === product.uid) {
                if (item.quantity > 1) {
                    item.quantity -= 1;
                } else {
                    this.products.splice(index, 1);
                }
                cartChange = true;
            }
        });
        if (cartChange) {
            this.events.publish('cart:update', this.getQuantityProducts());
            this.events.publish('cart:amount', this.getTotalPrice());
            return this.storage.set(CART_KEY, this.products);
        }

    }

    add(product: Product) {
        let isFound = false;
        for (let item of this.products) {
            if (item.id === product.id && item.uid === product.uid) {
                item.quantity += product.quantity;
                isFound = true;
                break;
            }
        }
        if (!isFound) {
            this.products.push(product);
        }
        this.events.publish('cart:update', this.getQuantityProducts());
        this.events.publish('cart:amount', this.getTotalPrice());
        return this.storage.set(CART_KEY, this.products);
    }

    replace(product: Product) {
        let isFound = false;
        if (product.uid === product.old_uid) {
            for (let item of this.products) {
                if (item.uid === product.old_uid) {
                    item.quantity = product.quantity;
                    break;
                }
            }
        } else {
            this.products.forEach((item, index) => {
                if (item.uid === product.old_uid) {
                    this.products.splice(index, 1);
                }
            });
            for (let item of this.products) {
                if (item.id === product.id && item.uid === product.uid) {
                    item.quantity += product.quantity;
                    isFound = true;
                    break;
                }
            }
            if (!isFound) {
                this.products.push(product);
            }
        }
        this.events.publish('cart:update', this.getQuantityProducts());
        this.events.publish('cart:amount', this.getTotalPrice());
        return this.storage.set(CART_KEY, this.products);
    }

    update(product: Product) {
        for (let item of this.products) {
            if (item.id === product.id && item.uid === product.uid) {
                item.quantity = product.quantity;
            }
        }
        this.events.publish('cart:update', this.getQuantityProducts());
        return this.storage.set(CART_KEY, this.products);
    }

    updateUsedDate(product: Product) {
        for (let item of this.products) {
            if (item.id === product.id && item.uid === product.uid) {
                item.used_date = product.used_date;
            }
        }
        // this.events.publish('cart:update', this.getQuantityProducts());
        return this.storage.set(CART_KEY, this.products);
    }

    updateMultiProducts(products: any) {
        console.log(products);
        for (let item of this.products) {
            item.message = '';
            if (products[item.uid]) {
                item.ori_price = products[item.uid].ori_price;
                if (item.options) {
                    item.options.map((op: ProductOption) => {
                        products[item.uid].options.map(new_op => {
                            if (op['id'] == new_op['id']) {
                                op['options'] = new_op['options'].map(op_item => new Option(op_item));
                            }
                        });
                    });
                }

                const tmp = new Product(item);
                tmp.getSalePrice();
                item.sale_price = tmp.sale_price;
                item.is_error = true;
                if (products[item.uid] && products[item.uid].message) {
                    item.message = products[item.uid].message;
                } else {
                    item.message = 'Đã cập nhật giá.';
                }

            }
        }
        this.events.publish('cart:update_price', this.products);
        return this.storage.set(CART_KEY, this.products);
    }

    syncCart(products: any) {
        for (let item of this.products) {
            item.message = '';
            if (products[item.uid]) {
                item.ori_price = +products[item.uid].ori_price;
                item.in_stock = +products[item.uid].in_stock;
                item.total_weigth = +products[item.uid].total_weigth;
                item.check_weight = products[item.uid].check_weight;
                item.check_quantity = products[item.uid].check_quantity;
                item.price = products[item.uid].price;
                if (item.options) {
                    item.options.map((op: ProductOption) => {
                        products[item.uid].options.map(new_op => {
                            if (op['id'] == new_op['id']) {
                                op['options'] = new_op['options'].map(op_item => new Option(op_item));
                            }
                        });
                    });
                }

                const tmp = new Product(item);
                tmp.getSalePrice();
                item.sale_price = tmp.sale_price;
                //item.getSalePrice();
                if (products[item.uid] && products[item.uid].message) {
                    item.message = products[item.uid].message;
                    item.is_error = true;
                    if (products[item.uid].calendar) {
                        item.minDate = new Date(products[item.uid].calendar['min_day']);
                        item.maxDate = new Date(products[item.uid].calendar['max_day']);
                        item.disabledDates = products[item.uid].calendar['dis_days'].map((item) => new Date(item));

                    }

                } else {
                    item.is_error = false;
                }

            }
        }
        this.events.publish('cart:sync', this.products);
        return this.storage.set(CART_KEY, this.products);
    }

    setCart(products: Array<Product>) {
        this.products = products;
        return this.storage.set(CART_KEY, this.products);
    }

    resetMessage() {
        for (let item of this.products) {
            item.message = '';
            item.is_error = false;

        }
        //this.events.publish('cart:update_price', this.getQuantityProducts());
        return this.storage.set(CART_KEY, this.products);
    }

    remove(product: Product) {
        this.products.forEach((item, index) => {
            if (item.id === product.id && item.uid === product.uid) {
                this.products.splice(index, 1);
            }
        });
        this.storage.set(CART_KEY, this.products);
        this.events.publish('cart:update', this.getQuantityProducts());
        this.events.publish('cart:amount', this.getTotalPrice());
        return this.products;
    }

    storePromotion(coupon: string, voucher: string, coupon_value: number, voucher_value: number) {
        this.coupon = coupon;
        this.voucher = voucher;
        this.coupon_value = coupon_value;
        this.voucher_value = voucher_value;
        this.storage.set(PROMOTION_KEY, {
            coupon: this.coupon,
            voucher: this.voucher,
            coupon_value: this.coupon_value,
            voucher_value: this.voucher_value
        }
        );
    }

    clear() {
        this.products = [];
        this.storage.set(CART_KEY, this.products);
        this.coupon = '';
        this.voucher = '';
        this.storage.set(PROMOTION_KEY, {
            coupon: this.coupon,
            voucher: this.voucher,
            coupon_value: 0,
            voucher_value: 0
        }
        );
        this.events.publish('cart:update', this.getQuantityProducts());
    }

    getQuantityProducts(): number {
        return this.products.reduce((preItem, item) => preItem + item.quantity, 0);
    }
    getTotalProducts() {
        return this.products.reduce((preItem, item) => preItem + item.quantity, 0);
    }

    getTotalPrice() {
        return this.products.reduce((preItem, item) => preItem + (item.quantity * item.sale_price), 0);

    }

    getCart() {
        return this.storage.get(CART_KEY);
    }
    getPromotion() {
        return this.storage.get(PROMOTION_KEY);
    }

    getProducts() {
        console.log(this.products);
        return this.products;
    }

    getTotalWeight() {
        let total = 0;
        this.products.map(item => {
            let totalItem = 0;
            totalItem += item.weight;
            console.log(item.weight);
            if (item.options) {
                item.options.map(op => {
                    op.options.map(subOp => {
                        if (op.selected.indexOf(subOp.id) > -1) {
                            if (subOp.weight_sign === '+') {
                                totalItem += subOp.weight;
                            } else {
                                totalItem -= subOp.weight;
                            }
                        }
                    })
                })
            }
            total += totalItem * item.quantity;
        });
        return total;
    }

}



// WEBPACK FOOTER //
// ./src/providers/cart/cart.ts